/**
 * @generated SignedSource<<293eb8c8d219b8b61f293811e9fb5699>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartmentType = "AQUATICS" | "AXE_THROWING" | "BASKETBALL" | "BOATING" | "BOCCE_BALL" | "BUSINESS" | "CARD_ROOM" | "CLUB" | "CROQUET" | "DINING" | "FITNESS" | "GOLF" | "HOCKEY" | "RACQUET" | "SALON" | "SHUFFLEBOARD" | "SPA";
export type MultiSlotBookingScreenRendererQuery$variables = {
  date: string;
};
export type MultiSlotBookingScreenRendererQuery$data = {
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly club: {
          readonly facilities: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly club: {
                  readonly supportsPublic: boolean;
                } | null | undefined;
                readonly courses: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly id: string;
                    } | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
                readonly department: {
                  readonly type: DepartmentType;
                } | null | undefined;
                readonly displayNameOrFacilityName: string;
                readonly id: string;
                readonly memberBookingWindowDays: number | null | undefined;
                readonly name: string;
                readonly slug: string;
                readonly " $fragmentSpreads": FragmentRefs<"AgendaDateSelectorControlFragment_facility" | "FiltersModalFragment_facility" | "MultiSlotSidebarFragment_facility" | "TeeSheetBasedFiltersModalFragment_facility" | "WaitlistModalFragment_Facility" | "getFacilityMemberPermissions_facility">;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly logoImage: {
            readonly publicId: string;
          } | null | undefined;
          readonly slug: string;
          readonly supportsPublic: boolean;
          readonly " $fragmentSpreads": FragmentRefs<"FacilityLogoFragment_club" | "TeeSheetAgendaHeaderFragment_club">;
        };
        readonly id?: string;
        readonly membershipType: {
          readonly id: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"FiltersModal_session" | "MultiSlotSidebarSessionFragment_session">;
  } | null | undefined;
};
export type MultiSlotBookingScreenRendererQuery = {
  response: MultiSlotBookingScreenRendererQuery$data;
  variables: MultiSlotBookingScreenRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "date"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "kind": "InlineFragment",
  "selections": (v2/*: any*/),
  "type": "Member",
  "abstractKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": (v2/*: any*/),
  "type": "Customer",
  "abstractKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPublic",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "logoImage",
  "plural": false,
  "selections": [
    {
      "alias": "publicId",
      "args": null,
      "kind": "ScalarField",
      "name": "renderingKey",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayNameOrFacilityName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberBookingWindowDays",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPrivate",
  "storageKey": null
},
v12 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityBookable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsJoinable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canBookOnBusySlot",
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicBookingPermissionSet",
  "kind": "LinkedField",
  "name": "publicBookingPermissionSet",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "PrivateBookingPermissionSet",
  "kind": "LinkedField",
  "name": "privateBookingPermissionSet",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = [
  (v16/*: any*/),
  (v1/*: any*/)
],
v18 = {
  "kind": "InlineFragment",
  "selections": (v2/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MultiSlotBookingScreenRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MultiSlotSidebarSessionFragment_session"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FiltersModal_session"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "membershipType",
                    "plural": false,
                    "selections": (v2/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TeeSheetAgendaHeaderFragment_club"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "FacilityLogoFragment_club"
                      },
                      (v1/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityConnection",
                        "kind": "LinkedField",
                        "name": "facilities",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FacilityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Facility",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "AgendaDateSelectorControlFragment_facility"
                                  },
                                  (v10/*: any*/),
                                  {
                                    "kind": "InlineDataFragmentSpread",
                                    "name": "getFacilityMemberPermissions_facility",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Club",
                                        "kind": "LinkedField",
                                        "name": "club",
                                        "plural": false,
                                        "selections": [
                                          (v1/*: any*/),
                                          (v11/*: any*/),
                                          (v6/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v13/*: any*/),
                                      (v14/*: any*/)
                                    ],
                                    "args": null,
                                    "argumentDefinitions": []
                                  },
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "TeeSheetBasedFiltersModalFragment_facility"
                                  },
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "WaitlistModalFragment_Facility"
                                  },
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "MultiSlotSidebarFragment_facility"
                                  },
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "FiltersModalFragment_facility"
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Department",
                                    "kind": "LinkedField",
                                    "name": "department",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Club",
                                    "kind": "LinkedField",
                                    "name": "club",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CourseConnection",
                                    "kind": "LinkedField",
                                    "name": "courses",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CourseEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Course",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v2/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MultiSlotBookingScreenRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityConnection",
                        "kind": "LinkedField",
                        "name": "facilities",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FacilityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Facility",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v1/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Club",
                                    "kind": "LinkedField",
                                    "name": "club",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      (v11/*: any*/),
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "calendarStartDay",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  (v5/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Department",
                                    "kind": "LinkedField",
                                    "name": "department",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v1/*: any*/),
                                      (v5/*: any*/),
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "publicBookingWindowDays",
                                    "storageKey": null
                                  },
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FacilityStartEndTime",
                                    "kind": "LinkedField",
                                    "name": "startEndTime",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "startTime",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "endTime",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "bookingType",
                                        "value": "STANDARD"
                                      }
                                    ],
                                    "concreteType": "GroupSize",
                                    "kind": "LinkedField",
                                    "name": "minMaxGroupSize",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "min",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "max",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "minMaxGroupSize(bookingType:\"STANDARD\")"
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "multipleBookingsEnabled",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CourseConnection",
                                    "kind": "LinkedField",
                                    "name": "courses",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CourseEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Course",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v1/*: any*/),
                                              (v8/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CourseLayoutConnection",
                                    "kind": "LinkedField",
                                    "name": "courseLayouts",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CourseLayoutEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CourseLayout",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "enabled",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "holeCount",
                                                "storageKey": null
                                              },
                                              (v1/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Variable",
                                        "name": "dateGte",
                                        "variableName": "date"
                                      },
                                      {
                                        "kind": "Variable",
                                        "name": "dateLte",
                                        "variableName": "date"
                                      }
                                    ],
                                    "concreteType": "AgendaConnection",
                                    "kind": "LinkedField",
                                    "name": "agendas",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AgendaEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Agenda",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "QueueSlot",
                                                "kind": "LinkedField",
                                                "name": "queueSlot",
                                                "plural": false,
                                                "selections": (v2/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": "waitlistRestrictions",
                                                "args": [
                                                  {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": [
                                                      "WAITLIST"
                                                    ]
                                                  }
                                                ],
                                                "concreteType": "AgendaBookingRulesConnection",
                                                "kind": "LinkedField",
                                                "name": "bookingRules",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AgendaBookingRulesEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "liftAt",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": null,
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": (v17/*: any*/),
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": "bookingRules(type:[\"WAITLIST\"])"
                                              },
                                              (v1/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/),
                      (v8/*: any*/),
                      (v7/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "membershipType",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "accb0bccf6d1ca0e5e7226db51100a1d",
    "id": null,
    "metadata": {},
    "name": "MultiSlotBookingScreenRendererQuery",
    "operationKind": "query",
    "text": "query MultiSlotBookingScreenRendererQuery(\n  $date: Date!\n) {\n  session {\n    ...MultiSlotSidebarSessionFragment_session\n    ...FiltersModal_session\n    currentClientProfile {\n      __typename\n      member {\n        __typename\n        ... on Member {\n          id\n        }\n        ... on Customer {\n          id\n        }\n        membershipType {\n          __typename\n          id\n        }\n        club {\n          ...TeeSheetAgendaHeaderFragment_club\n          ...FacilityLogoFragment_club\n          id\n          slug\n          supportsPublic\n          logoImage {\n            publicId: renderingKey\n          }\n          facilities {\n            edges {\n              node {\n                id\n                name\n                displayNameOrFacilityName\n                slug\n                ...AgendaDateSelectorControlFragment_facility\n                memberBookingWindowDays\n                ...getFacilityMemberPermissions_facility\n                ...TeeSheetBasedFiltersModalFragment_facility\n                ...WaitlistModalFragment_Facility\n                ...MultiSlotSidebarFragment_facility\n                ...FiltersModalFragment_facility\n                department {\n                  type\n                  id\n                }\n                club {\n                  supportsPublic\n                  id\n                }\n                courses {\n                  edges {\n                    node {\n                      id\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment AgendaDateSelectorControlFragment_facility on Facility {\n  id\n  publicBookingWindowDays\n  memberBookingWindowDays\n  club {\n    supportsPrivate\n    ...useGetClubStartOfWeekNumberPatron_club\n    id\n  }\n}\n\nfragment FacilityLogoFragment_club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment FiltersModalFragment_facility on Facility {\n  id\n  slug\n  name\n  type\n  ...AgendaDateSelectorControlFragment_facility\n  ...facilityToScheduleOption_facility\n}\n\nfragment FiltersModal_session on Session {\n  ...ScheduleSwitcher_session\n}\n\nfragment MultiSlotSidebarFragment_facility on Facility {\n  id\n  slug\n  name\n  type\n  ...AgendaDateSelectorControlFragment_facility\n  ...facilityToScheduleOption_facility\n}\n\nfragment MultiSlotSidebarSessionFragment_session on Session {\n  ...ScheduleSwitcher_session\n}\n\nfragment ScheduleSwitcher_session on Session {\n  ...useGetScheduleSwitcherOptionsFragment_session\n}\n\nfragment TeeSheetAgendaHeaderFragment_club on Club {\n  name\n  ...FacilityLogoFragment_club\n}\n\nfragment TeeSheetBasedFiltersModalFragment_facility on Facility {\n  id\n  club {\n    supportsPrivate\n    id\n  }\n  ...useFacilityStartEndTime_facility\n  ...useFacilityGroupSize_facility\n  ...TeeSheetCourseSelectorControlFragment_facility\n  ...TeeSheetMultipleBookingToggleFragment_Facility\n  ...AgendaDateSelectorControlFragment_facility\n  ...facilityToScheduleOption_facility\n  ...TeeSheetHoleCountSelectorControl_facility\n}\n\nfragment TeeSheetCourseSelectorControlFragment_facility on Facility {\n  id\n  name\n  slug\n  multipleBookingsEnabled\n  courses {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment TeeSheetHoleCountSelectorControl_facility on Facility {\n  id\n  courseLayouts {\n    edges {\n      node {\n        enabled\n        holeCount\n        id\n      }\n    }\n  }\n}\n\nfragment TeeSheetMultipleBookingToggleFragment_Facility on Facility {\n  multipleBookingsEnabled\n}\n\nfragment WaitlistModalFragment_Facility on Facility {\n  agendas(dateGte: $date, dateLte: $date) {\n    edges {\n      node {\n        queueSlot {\n          id\n        }\n        waitlistRestrictions: bookingRules(type: [WAITLIST]) {\n          edges {\n            liftAt\n            node {\n              __typename\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment departmentToScheduleOption_department on Department {\n  type\n  id\n  slug\n  name\n}\n\nfragment facilityToScheduleOption_facility on Facility {\n  id\n  slug\n  name\n  type\n  department {\n    type\n    id\n  }\n}\n\nfragment getFacilityMemberPermissions_facility on Facility {\n  club {\n    id\n    supportsPrivate\n    supportsPublic\n  }\n  publicBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n  privateBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n}\n\nfragment useFacilityGroupSize_facility on Facility {\n  minMaxGroupSize(bookingType: STANDARD) {\n    min\n    max\n  }\n}\n\nfragment useFacilityStartEndTime_facility on Facility {\n  startEndTime {\n    startTime\n    endTime\n  }\n}\n\nfragment useGetClubStartOfWeekNumberPatron_club on Club {\n  calendarStartDay\n}\n\nfragment useGetScheduleSwitcherOptionsFragment_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        facilities {\n          edges {\n            node {\n              type\n              id\n              ...getFacilityMemberPermissions_facility\n              ...facilityToScheduleOption_facility\n              department {\n                id\n                type\n                ...departmentToScheduleOption_department\n              }\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0abbd7feb8b46612cd36c6d7fb47b9e8";

export default node;
